<div id="public-security-container" class="secondary-background-color">
    <div class="section-title-container">
        <h2 class="section-title">Seguridad pública</h2>
    </div>

    <div id="public-security-content-container" >
        @for (card of cards; track $index) {
            <app-section-card class="public-security-card" [type]="'public-security'" [card]="card"></app-section-card>
        }
    </div>
</div>

